var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIdentificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 8.33333C9.33335 9.06973 8.73642 9.66667 8.00002 9.66667C7.26362 9.66667 6.66669 9.06973 6.66669 8.33333C6.66669 7.59693 7.26362 7 8.00002 7C8.73642 7 9.33335 7.59693 9.33335 8.33333Z",
    fill: "currentFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.5C7.81767 11.5 7.54574 11.5914 7.12154 11.9874C6.8524 12.2386 6.43052 12.2241 6.1793 11.9549C5.92808 11.6857 5.94262 11.2639 6.21179 11.0126C6.73994 10.5197 7.3252 10.1667 8 10.1667C8.6748 10.1667 9.26007 10.5197 9.7882 11.0126C10.0574 11.2639 10.0719 11.6857 9.82074 11.9549C9.56947 12.2241 9.1476 12.2386 8.87847 11.9874C8.45427 11.5914 8.18234 11.5 8 11.5Z",
    fill: "currentFill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66669 3.33334C2.66669 2.22878 3.56212 1.33334 4.66669 1.33334H11.3334C12.438 1.33334 13.3334 2.22878 13.3334 3.33334V12.6667C13.3334 13.7713 12.438 14.6667 11.3334 14.6667H4.66669C3.56212 14.6667 2.66669 13.7713 2.66669 12.6667V3.33334ZM4.66669 2.66668C4.2985 2.66668 4.00002 2.96516 4.00002 3.33334V12.6667C4.00002 13.0349 4.2985 13.3333 4.66669 13.3333H11.3334C11.7016 13.3333 12 13.0349 12 12.6667V3.33334C12 2.96516 11.7016 2.66668 11.3334 2.66668H4.66669Z",
    fill: "currentFill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.66667C6 4.29848 6.29848 4 6.66667 4H9.33333C9.70153 4 10 4.29848 10 4.66667C10 5.03485 9.70153 5.33333 9.33333 5.33333H6.66667C6.29848 5.33333 6 5.03485 6 4.66667Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIdentificationIcon);
export default __webpack_public_path__ + "static/media/contactIdentificationIcon.f756e6d437b3f4fe9d19b94db14ac39a.svg";
export { ForwardRef as ReactComponent };